
    import { Component, Vue, Watch } from 'vue-property-decorator'
    @Component({
        name: 'DashAboutfangtian'
    })
    export default class DashAboutfangtian extends Vue {
    }
